/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyOfficeCreateDto } from '../../models/company-office-create-dto';
import { CompanyOfficeItem } from '../../models/company-office-item';

export interface OfficeControllerRegisterOfficeToCompany$Params {
      body: CompanyOfficeCreateDto
}

export function officeControllerRegisterOfficeToCompany(http: HttpClient, rootUrl: string, params: OfficeControllerRegisterOfficeToCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerRegisterOfficeToCompany.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanyOfficeItem;
      }>;
    })
  );
}

officeControllerRegisterOfficeToCompany.PATH = '/company/office';
